// ADD: Key for storing the array of all country product data in Redis
export const REDIS_ALL_STRIPE_PRODUCTS_CACHE_KEY = `${
  process.env.VERCEL_ENV || "development"
}:stripe:products:regional`;

// Cache duration in seconds (e.g., 6 hours)
export const REDIS_CACHE_TTL_SECONDS = 6 * 60 * 60;

// --- GET Route Product Country Identification ---
// Metadata key on the cached Stripe Product object containing the 2-char country identifier (e.g., 'US', 'NL', 'XX')
export const STRIPE_PRODUCT_METADATA_COUNTRY_KEY = "country";
// Value in STRIPE_PRODUCT_METADATA_COUNTRY_KEY identifying the global fallback product
export const STRIPE_GLOBAL_DEFAULT_PRODUCT_COUNTRY = "XX";
